import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "../../Styles/Itinerary.module.scss";
import pictureOne from "./../../img/Ireland/Itinerary_1.jpeg";
import pictureTwo from "./../../img/Ireland/Itinerary_2.jpeg";
import pictureThree from "./../../img/Ireland/Itinerary_3.jpeg";

function ItalyItinerary() {
  const tripExample = [
    {
      day: "Day 1",
      text: ["Leave the USA"]
    },
    {
      day: "Day 2",
      text: [
        "Arrive Dublin / depending on arrival we will use half day for touring",
        "(Stay in Dublin)"
      ]
    },
    {
      day: "Day 3",
      text: [
        "Morning for touring Dublin",
        "Trinity College",
        "St Patrick’s Cathedral",
        "Chester Beatty Museum: Biblical manuscripts",
        "Travel to Belfast",
        "(Stay in Belfast)"
      ]
    },
    {
      day: "Day 4",
      text: [
        "Tour Belfast: the Titanic Experience, Guided Tour of Belfast and the “Troubles”,",
        "(Stay in Belfast)"
      ]
    },
    {
      day: "Day 5",
      text: [
        "Climb Slemish Mountain: the traditional mountain/hill where St Patrick, as a slave, took care of sheep. Pilgrims climb his mountain/hill every St. Patrick Day, March 17th.",
        "Northeast Coastline",
        "Giant’s Causeway",
        "(Stay in Londonderry/Derry)"
      ]
    },
    {
      day: "Day 6",
      text: [
        "Tour Londonderry in the morning",
        "Stop for lunch in Donegal",
        "(Stay in County Donegal)"
      ]
    },
    {
      day: "Day 7",
      text: ["Visit Sheep Farm", "Travel to Galway (3 hrs)", "(Stay in Galway)"]
    },
    {
      day: "Day 8",
      text: ["Tour Galway", "(Stay in Galway)"]
    },
    {
      day: "Day 9",
      text: ["Moher Cliffs and drive to Dublin", "(Stay in Dublin)"]
    },
    {
      day: "Day 10",
      text: ["Fly home"]
    }
  ];
  const tripSeptember = [
    {
      day: "Day 1 - Monday, September 14",
      text: ["Leave the USA"]
    },
    {
      day: "Day 2 - Tuesday, September 15",
      text: [
        "Arrive Dublin / depending on arrival we will use half day for touring",
        "(Stay in Dublin)"
      ]
    },
    {
      day: "Day 3 - Wednesday, September 16",
      text: [
        "Morning for touring Dublin",
        "Trinity College",
        "St Patrick’s Cathedral",
        "Chester Beatty Museum: Biblical manuscripts",
        "Travel to Belfast",
        "(Stay in Belfast)"
      ]
    },
    {
      day: "Day 4 - Thursday, September 17",
      text: [
        "Tour Belfast: the Titanic Experience, Guided Tour of Belfast and the “Troubles”,",
        "(Stay in Belfast)"
      ]
    },
    {
      day: "Day 5 - Friday, September 18",
      text: [
        "Climb Slemish Mountain: the traditional mountain/hill where St Patrick, as a slave, took care of sheep. Pilgrims climb his mountain/hill every St. Patrick Day, March 17th.",
        "Northeast Coastline",
        "Giant’s Causeway",
        "(Stay in Londonderry/Derry)"
      ]
    },
    {
      day: "Day 6 - Saturday, September 19",
      text: [
        "Tour Londonderry in the morning",
        "Stop for lunch in Donegal",
        "(Stay in County Donegal)"
      ]
    },
    {
      day: "Day 7 - Sunday, September 20",
      text: ["Visit Sheep Farm", "Travel to Galway (3 hrs)", "(Stay in Galway)"]
    },
    {
      day: "Day 8 - Monday, September 21",
      text: ["Tour Galway", "(Stay in Galway)"]
    },
    {
      day: "Day 9 - Tuesday, September 22",
      text: ["Moher Cliffs and drive to Dublin", "(Stay in Dublin)"]
    },
    {
      day: "Day 10 - Wednesday, September 23",
      text: ["Fly home"]
    }
  ];

  const params = useParams();

  let dates = "";
  let trip = [];

  switch (params.trip) {
    case "September-26":
      dates = "September 14 - 23, 2026";
      trip = tripSeptember;
      break;

    case "trip":
      dates = "";
      trip = tripExample;
      break;
  }

  return (
    <div className="pageContainer">
      <p className="title">Itinerary</p>
      <p className="secondaryTitle">{dates}</p>

      <div className="pictureRow">
        <div>
          <img className="picture" src={pictureOne} alt="Ireland" />
        </div>
        <div className="hide">
          <img className="picture" src={pictureTwo} alt="Ireland" />
        </div>
        <div>
          <img className="picture" src={pictureThree} alt="Ireland" />
        </div>
      </div>
      <p className="text">
        There will probably additional stops/sites other than what is listed on
        this itinerary.
      </p>
      {trip.map((item, i) => (
        <div key={i} className={styles.IsraelItinerary}>
          <h2 className={styles.dayNumber}>{item.day}</h2>
          <ul className={styles.list}>
            {item.text.map((par, i) => (
              <li className={styles.listItem} key={i}>
                {par}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

export default ItalyItinerary;
